<template>
    <div data-test-id="l-space" :style="`height: ${size * 15}px;`"></div>
</template>

<script>
export default {
    props: {
        size: {
            type: Number,
            required: true,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped></style>
